import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html'
})
export class ConfirmComponent implements OnInit {

  @Input() message: string;
  @Input() cancelText: string;
  @Input() confirmText: string;
  @Output() confirm: EventEmitter<void> = new EventEmitter<void>();

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

  onClose() {
    this.activeModal.close();
  }

  onSave() {
    this.confirm.emit();
    this.activeModal.close();
  }
}
